import React from 'react'

export default () => {
  return (
    <div className="ant-modal-body"><p> 版本发布日期：2023年12月15日</p><p> 版本生效日期：2023年12月15日</p>
      <p><h4>【目录】</h4></p>
      <p> 一、引言</p><p> 二、 关于我们</p><p> 三、 名词解释</p><p> 四、 我们如何收集和使用您的个人信息</p>
      <p> 五、 我们如何使用 Cookie和同类技术</p><p> 六、 我们如何共享、转让、公开披露您的个人信息</p><p> 七、
        我们对您个人信息的存储与保护</p><p> 八、 您管理个人信息的权利</p>
      <p> 九、 我们如何处理未成年人的个人信息</p><p> 十、 我们对去世用户的个人信息保护</p><p> 十一、 本政策如何更新</p>
      <p> 十二、 如何联系我们</p><p> 十三、 争议解决</p>
      <p><h4>一、引言</h4></p>
      <p> 1.欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全。基于此，SIMBOSS物联网业务服务提供者（或简称“我们”）制定本《个人信息保护政策》（下称“本政策”），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、存储、使用、加工、传输、提供、公开、删除和保护您的个人信息，以及您可以如何管理您的个人信息，以便您更好地做出适当的选择。</p>
      <p>
        <b>2.在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体/粗体下划线标识的条款，确保您充分理解和同意之后再开始使用。一旦您使用或继续使用我们的产品和服务，即表示您同意我们按照本政策使用和处理您的相关信息。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如对本政策内容有任何疑问、意见或建议，您可通过我们提供的联系方式与我们联系。</b>
      </p>
      <p>
        <b>3.我们可能会不时依据法律法规或业务调整对本政策进行修订。当本政策发生变更后，我们会在版本更新后通过在显著位置提示或推送通知、消息等形式向您展示变更后的内容。</b>
      </p>
      <p>
        <b> 4.您需理解，只有在您确认并同意变更后的政策，我们才会依据变更后的政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的政策，但请您知悉，一旦您拒绝同意变更后的政策，可能导致您不能或不能继续完整使用我们的相关服务和功能，或者无法达到我们拟达到的服务效果。</b>
      </p>
      <p><h4>二、 关于我们</h4></p>
      <p> 1.SIMBOSS（芯博士）是深耕物联网行业的明星品牌，致力于让万物互联更简单。SIMBOSS由杭州芯博士网络科技有限公司（以下简称“芯博士”）及其关联公司提供产品运营和服务。</p>
      <p> 2.
        关联公司包括芯博士现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。</p>
      <p><h4>三、 名词解释</h4></p>
      <p> 除非另有约定，本政策中使用到的名词，通常仅具有以下定义：</p>
      <p> 1.<b>个人信息</b>（出自于《个人信息保护法》）：个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
      </p>
      <p> 2.<b>敏感个人信息</b>（出自于《个人信息保护法》）：敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
      </p>
      <p> 3.<b>账号</b>：当您登录访问时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。</p>
      <p> 4.<b>匿名化</b>（出自于《个人信息保护法》）：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
      <p> 5.<b>去标识化</b>（出自于《个人信息保护法》）：是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
      </p>
      <p> 6.<b>Cookie：</b>是指包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。
      </p>
      <p><h4>四、我们如何收集和使用您的个人信息</h4></p>
      <p> 1.我们依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品和服务需要而收集、产生的个人信息。<b>如果我们欲将您的个人信息用于本政策未载明的其他用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。</b>
      </p>
      <p> 2.我们收集和使用的您的个人信息类型包括两种：第一种：<b>我们产品和服务的核心业务功能所必需的信息：此类信息为产品和服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品和服务。</b>第二种：<b>附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。</b>
      </p>
      <p> 3.我们需要特别提醒您的是：我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，包括技术，这意味着我们可能会推出新的业务功能，可能需要收集新的个人信息或变更个人信息使用目的或方式。<b>如果某一需要收集您的个人信息的功能未能在本政策中予以说明的，我们会通过更新本政策、页面提示、弹窗等方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。</b>在此过程中，如果您对相关事宜有任何疑惑的，可以通过本政策提供的方式联系我们，我们会尽快为您做出解答。
      </p>
      <p> 4. 通常情况下，我们会在以下场景中收集和使用您的个人信息：</p><p> 4.1 用户注册、资质认证、登录</p>
      <p> （1）为创建账号，您需要向我们提供您的<b>电话号码、电话验证码、姓名、公司名称、行业信息</b>。如果您拒绝提供上述信息，您将无法注册账号，仅可以使用浏览服务。我们部分产品和服务，需要您完成资质认证：若您为<b>个人用户</b>则需提供<b>电话号码、电话验证码</b>；若您为企业用户则需要提供<b>企业名称、工商营业执照注册号、营业执照扫描件或照片、法定代表人身份证号以及身份证照片</b>进行资质认证。<b>一旦您确认并继续使用本产品，我们将视为您同意我们收集前述相关个人信息。</b>
      </p>
      <p> （2）您可以使用密码登录，登录时您需要填入您的电话号码，以及密码。我们承诺，收集上述信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。</p>
      <p> （3）同时，您需理解，<b>身份证号、身份证照片、电话号码和验证码匹配结果属于您的个人敏感信息，</b>我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法登录账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。
      </p>
      <p> 4.2财务管理</p>
      <p> （1）当您通过第三方支付进行线上充值功能时，你需要提供您的<b>第三方支付账号信息才能完成支付功能（例如支付宝账号）。</b>
      </p>
      <p> （2）当您通过银行转账进行线下充值功能时，您需要提供您的<b>充值金额、付款账户名、付款账号、付款凭证、开户账号。</b></p>
      <p> （3）当您在平台相关功能页面处申请开具电子发票时，如为普通电子发票，您需要提供您的<b>发票抬头、纳税人识别号，以及收件人姓名、电话号码和地址</b>；如您需要开具增值税专用发票，您需要提供<b>发票抬头、纳税人识别号、公司注册地址、公司注册电话、基本户开户银行、基本户开户账号、基本户开户名、公司营业执照照片和一般纳税人证书照片，以及收件人姓名、电话号码和地址。</b>
      </p>
      <p> （4）<b>我们承诺上述信息收集仅用于进行充值及开具发票。</b>如您拒绝提供可能导致您无法进行账号充值或发票开具，请您谨慎考虑后再选择是否提供。
      </p>
      <p> 4.3系统设置</p>
      <p> 为了您通过系统设置设定您的信息处理与接收状态，您需要提供您的<b>服务器IP地址</b>。如您拒绝提供可能导致您无法使用相关产品功能，请您谨慎考虑后再选择是否提供。
      </p>
      <p> 4.4 申诉与反馈</p>
      <p> 当您通过本政策中公布的联系方式进行个人信息申诉与反馈时，<b>为了您的账号与系统安全，若您为个人用户，我们可能需要您提供个人姓名、电话号码、身份证号码以验证您个人信息的真实性；若您为企业用户需要您提供企业名称、工商营业执照注册号、营业执照扫描件或照片以验证企业信息的真实性。</b>我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
      </p>
      <p> 4.5 从第三方间接收集的您的个人信息</p>
      <p>
        <b>您理解并知悉，您向外部第三方提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式（如：恶意干预对方数据）擅自以软件程序获得您的个人信息。</b>我们可能因业务发展的需要而确实需要从第三方间接收集（如共享等）您的个人信息的，且由我们直接或共同为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得您的授权同意）。
      </p>
      <p>4.6、发货收件人信息、告警通知、微信公众号、小程序账号绑定。</p>
      <p><h4>五、我们如何使用 Cookie和同类技术</h4></p>
      <p> 您理解并知悉：我们的某些产品和服务只能通过使用Cookie才可得到实现，如您拒绝使用或删除的，您可能无法通过我们的产品和服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</p>
      <p><h4>六、我们如何共享、转让、公开披露您的个人信息</h4></p>
      <p> （一）共享</p>
      <p> 1.我们重视对您个人信息的保护，您的个人信息是我们为您提供产品和服务的重要依据和组成部分，对于您的个人信息，我们仅在本政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。<b>为了向您提供更完善、优质的产品和服务，我们的某些服务将由关联公司或者合作伙伴提供。我们可能会与合作伙伴或者关联公司共享您的某些个人信息，以提供更好的服务和功能。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。如果您拒绝我们的合作伙伴或者关联公司在提供服务时收集为提供服务所必需的个人信息，将可能导致您无法在我们的产品中使用相关服务。</b>
      </p>
      <p> 2.我们不会与关联公司及完成业务功能必要的合作伙伴以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
      <p><b>（1）事先已明确获取您单独同意的情况。</b></p>
      <p><b>（2）我们可能会根据法律法规规定，或按政府主管部门的强制性要求、司法裁定对外共享您的个人信息。</b></p>
      <p>
        <b>（3）法律要求或允许的范围内，为了保护用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方。</b>
      </p>
      <p> （二）转让</p>
      <p><b>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</b></p>
      <p> 1.在获取明确<b>单独同意</b>的情况下转让：获得您的<b>单独同意</b>后，我们会向其他方转让您的个人信息；</p>
      <p> 2.在涉及合并、分立、解散、被宣告破产等原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方应当继续履行本协议约定的义务。接收方变更原先的处理目的、处理方式的，应当重新取得您的同意。</p>
      <p> （三）公开披露</p>
      <p>
        <b>1.我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的单独同意后再公开披露，但法律法规另有规定的或本政策另有约定的除外。</b>
      </p>
      <p> 2.对于公开披露的您的个人信息，我们会在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取最严格个人信息安全保护措施和手段对其进行保护。</p>
      <p> （四）共享、转让、公开披露您的个人信息的例外</p>
      <p><b>请您知悉，根据法律法规的规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</b></p>
      <p> 1.与国家安全、国防安全直接相关的；</p><p> 2.与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p> 3.与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；</p>
      <p> 4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
      <p> 5.个人信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；</p>
      <p> 6.根据与您签订和履行相关协议或其他书面文件所必需的；</p>
      <p> 7.法律法规等规定的其他情形。</p>
      <p><h4>七、 我们对您个人信息的存储与保护</h4></p>
      <p> （一）我们如何存储您的个人信息</p>
      <p> 1.信息存储地点</p><p> 我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
      <p> 2.信息存储的期限</p>
      <p> （1）我们承诺您的个人信息的存储期限为实现处理目的所必要的最短时间，例如：当您使用我们的注册、登录功能时，我们需要收集您的密码、电话号码，且在您提供后并在您使用该功能期间，我们需要持续保存您的密码、电话号码，以向您正常提供该功能、保障您的账号和系统安全。此外，我们或对您的相关信息保存至相关法律所规定的必要期限。</p>
      <p> （2）在您终止使用SIMBOSS服务6个月后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。</p>
      <p> 3.信息删除的存储</p>
      <p> 在您注销账号后，我们将对您的个人信息进行删除或匿名化处理。当您或我们协助您删除相关信息后，因为适用的法律法规要求和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步处理，直到备份可以删除或实现匿名化。</p>
      <p> （二）我们如何保护您的个人信息</p>
      <p> 我们会严格按照《个人信息保护法》、《网络安全法》、《数据安全法》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。</p>
      <p><b>1.我们保护您个人信息的技术和措施</b></p>
      <p> 我们非常重视个人信息安全，并采取一切合理可行的措施保护您的个人信息：</p>
      <p><b>（1）数据安全技术措施</b></p>
      <p> 我们采取多种复杂数据脱敏技术，采取SSL传输层安全协议，来增强个人信息在使用中的安全性。同时，我们采取加密算法对您的登录密码进行加密。我们建立了严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。我们采用代码安全检查、数据访问日志分析技术进行个人信息安全审计。</p>
      <p><b>（2）其他安全措施</b></p>
      <p> 我们通过信息接触者保密协议与关键岗位人员背景审查来对数据进行全面安全控制。我们通过采用操作页面敏感信息保护措施，来推进和保障个人信息安全。</p>
      <p>
        <b> 2.请您理解：互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性，但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</b>
      </p>
      <p><h4>八、 您管理个人信息的权利</h4></p>
      <p> 我们理解您对个人信息的关注，并尽全力确保您对于自己个人信息访问、更正、删除以及撤回授权的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
      <p><b>1. 您有权访问您的个人信息</b></p>
      <p> 您可以按照我们提供的产品和服务的相关说明（或设置），对您已提供给我们的相关个人信息进行查阅。包括：</p>
      <p>1.1<b>账号信息及资质认证信息</b>：您可以通过相关产品页面随时登录您的账户设置，以访问您账号中的个人资料信息。</p>
      <p> 1.2 <b>财务信息</b>：您可以通过相关产品页面查看您的充值金额、购买记录、付款信息。</p><p> 1.3
        <b>系统信息</b>：您可以通过相关产品页面查看您的服务器IP地址。</p><p> 1.4
        <b>其他信息</b>：如您在访问过程中遇到操作问题需获取其他前述无法获知的个人信息内容，您可通过本政策提供的方式联系我们。
      </p>
      <p> 2.更正/修改您的个人信息</p>
      <p> 当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，您可在我们的产品和服务中更正/修改您的个人信息。</p>
      <p> 3. 您有权删除您的个人信息</p><p> 3.1
        您可以通过本政策中公示的联系方式向我们申请删除您的个人信息。信息删除后，我们会立即对此类信息进行删除或匿名化处理，除非法律法规另有规定。</p>
      <p> 3.2
        当发生以下情况时，您可以直接要求我们删除您的个人信息，但已做匿名化处理或法律法规另有规定的除外：</p>
      <p> （1）如果我们处理个人信息的行为违反法律法规；</p>
      <p> （2）如果我们收集、使用您的个人信息，却未征得您的同意；</p><p> （3）如果我们处理个人信息的行为违反了与您的约定；</p>
      <p> （4）如果您不再使用我们的产品或服务，或您注销了账号；</p>
      <p> （5）如果我们不再为您提供产品或服务。</p><p> 3.3
        当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p><p> 3.4
        您注销账号之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
      <p> 4.您有权撤回您对个人信息的授权</p>
      <p> 您可以通过本政策中公示的联系方式向我们申请撤回关于您个人信息的授权。当您撤回个人信息授权后，您可能不能或不能完整使用我们的相关服务和功能，或者无法达到我们拟达到的服务效果。</p>
      <p> 5.您有权注销您的账号</p>
      <p> 您可以通过本政策中公示的联系方式向我们申请注销账号。当您注销账号后，您将无法再以该账号登录和使用我们的产品与服务；且该账号在我们产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益等全部权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外，如依据《中华人民共和国网络安全法》规定，您的网络操作日志将至少保留六个月的时间）；账号注销完成后，将无法恢复。</p>
      <p> 6.您有权获取您的个人信息副本</p>
      <p> 您可以通过本政策中公示的联系方式向我们申请获取个人信息副本。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。</p>
      <p> 7.约束信息系统自动决策</p>
      <p> 在某些业务功能中，我们可能仅依据算法在内的非人工自动决策机制做出决定。如果这些决定影响您的合法权益，您可以通过本政策中公示的联系方式联系我们。</p>
      <p> 8.您有权请求将个人信息转移至您指定的个人信息处理者</p>
      <p> 您可以通过本政策中公示的联系方式向我们申请转移您的个人信息至您指定的个人信息处理者。在符合国家网信部门规定条件且技术可行的前提下，我们将根据您的要求将您的个人信息转移至您指定的个人信息处理者。</p>
      <p><h4>九、我们如何处理未成年人的个人信息</h4></p>
      <p> 我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务/或产品前，应事先取得您家人或法定监护人的书面同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。</p>
      <p><h4>十、我们对去世用户的个人信息保护</h4></p>
      <p> 1.我们的个人用户去世后，其近亲属为了自身的合法、正当利益，可以通过本政策中公示的联系方式，对去世个人的相关个人信息行使查阅、复制、更正、删除等权利，但是去世个人生前另有安排的除外。</p>
      <p> 2.
        您理解并确认，为了充分保护去世用户的个人信息权益，申请行使本条权利的去世用户近亲属需要根据我们的指定流程或客服提示，提交去世用户的身份证明文件、死亡证明文件、申请人的身份证明文件、申请人与去世用户的亲属关系证明文件，并提供申请行使的权利种类、目的。</p>
      <p><h4>十一、本政策如何更新</h4></p>
      <p>
        <b>1.为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本政策的条款，该等更新构成本政策的一部分。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们将在更新后的本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，如该等更新造成您在本政策下权利的实质减少或重大变更，我们会再次征求您的明示同意。</b>
      </p>
      <p><b> 2. 重大变更包括但不限于：</b></p><p> 2.1
        我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p><p> 2.2
        我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p><p> 2.3
        个人信息共享、转让或公开披露的主要对象发生变化；</p><p> 2.4
        您参与个人信息处理方面的权利及其行使方式发生重大变化；</p><p> 2.5
        我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p><p> 2.6
        个人信息安全影响评估报告表明存在高风险时。</p>
      <p><h4>十二、如何联系我们</h4></p>
      <p> 1.如果您对本政策有任何疑问、意见或建议，您均可以通过如下任一方式与我们取得联系：</p><p> 1.1
        您可以拨打客服热线：400-668-5196；</p><p> 1.2
        您可以向service@simboss.com客服邮箱或者marketing@simboss.com 市场邮箱发送邮件。</p>
      <p> 2.此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</p>
      <p>2.1 与国家安全、国防安全有关的；</p><p> 2.2 与公共安全、公共卫生、重大公共利益有关的；</p>
      <p> 2.3 与犯罪侦查、起诉和审判等有关的；</p><p> 2.4 有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p> 2.5 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
      <p> 2.6 涉及商业秘密的；</p><p> 2.7 法律法规等规定的其他情形。</p>
      <p><h4>十三、 争议解决</h4></p>
      <p>1.本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。<b>任何因本政策以及我们处理您个人信息事宜引起的争议，您同意向杭州仲裁委员会提起仲裁解决；该仲裁一裁终局，对双方均具有法律约束力。</b>
      </p>
      <p>2.本政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。</p>
    </div>
  )
}
